export default __webpack_public_path__ + "static/media/vuesax-linear-profile-2user.bb20e1aa.svg";